var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34063",
    "data-name": "Group 34063",
    transform: "translate(-15.969 -12.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check_box",
    "data-name": "Check box",
    transform: "translate(15.838 12.376)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3854",
    "data-name": "Rectangle 3854",
    width: 39,
    height: 39,
    transform: "translate(0.131 0.131)",
    fill: "#a54545",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "folder-2",
    transform: "translate(21.469 19.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67906",
    "data-name": "Path 67906",
    d: "M0,189.569V200.08a5.84,5.84,0,0,0,5.833,5.833H22.167A5.84,5.84,0,0,0,28,200.08V189.44Z",
    transform: "translate(0 -180.247)",
    fill: "#575b64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67907",
    "data-name": "Path 67907",
    d: "M22.167,23.667H14.551a1.189,1.189,0,0,1-.522-.117L10.347,21.7a3.516,3.516,0,0,0-1.565-.369H5.833A5.84,5.84,0,0,0,0,27.167v1.156l27.84-.13A5.833,5.833,0,0,0,22.167,23.667Z",
    transform: "translate(0 -21.334)",
    fill: "#575b64"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubFolder);
export default __webpack_public_path__ + "static/media/sub-folder.0d241cfae3784d28eecf5f73fb7048bb.svg";
export { ForwardRef as ReactComponent };